import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgShieldDoneFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m15.575 10.33-3.722 3.72a.75.75 0 0 1-1.06-.001l-1.806-1.81a.749.749 0 1 1 1.062-1.058l1.275 1.277 3.19-3.189a.75.75 0 1 1 1.061 1.061m3.781-5.193C18.653 4.431 13.026 2.5 12 2.5c-1.026 0-6.653 1.931-7.357 2.637-.56.562-.552.996-.508 3.397.018.974.042 2.3.042 4.136 0 6.407 7.601 8.785 7.678 8.808a.48.48 0 0 0 .29 0c.077-.023 7.68-2.401 7.68-8.808 0-1.831.023-3.155.041-4.128.043-2.407.05-2.842-.509-3.405"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgShieldDoneFilled);
export default ForwardRef;
